import { render } from "./JournalAnnualPanel.vue?vue&type=template&id=628230c4&scoped=true"
import script from "./JournalAnnualPanel.vue?vue&type=script&lang=js"
export * from "./JournalAnnualPanel.vue?vue&type=script&lang=js"

import "./JournalAnnualPanel.vue?vue&type=style&index=0&id=628230c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628230c4"]])

export default __exports__